<template>
  <div class="downloadMask2 pa center pr txtCon tal" v-if="isShowTxt">
    <h4 class="clearfix">安全中心用户服务协议</h4>
    <b class="pa closeBtn cp" @click="isShowTxt = !isShowTxt">×</b>
    <div class="inCon">
      <!-- <p>
          杭州云智互联科技有限公司（以下称“云智互联”）请您务必仔细阅读和理解维护大师软件最终用户许可协议（“本《协议》”）中规定的所有权利和限制。在安装及使用时，您需要仔细阅读并决定接受或不接受本《协议》的条款。除非或直至您接受本《协议》的条款，如果您不同意以下任何一点，请立即停止使用并卸载此软件。
          您单击“同意”按钮，即表示您签名完全接受本《协议》的所有内容。
        </p>
        <p>
          本《协议》是您与云智互联之间有关本“软件”的法律协议。本“软件”包括随附的计算机软件，并可能包括相关文档印刷材料。您一旦安装本“软件”，即表示您同意接受本《协议》各项条款的约束。如您不同意本《协议》中的条款，您则不可以安装或使用本“软件”。
          本“软件”知识产权归云智互联所有，“软件”的结构、组织、代码以及与软件相关的信息均属于云智互联的商业秘密和保密信息，受著作权法及国际著作权条约和其它知识产权法和条约的保护。本“软件”权利只许可使用，而不出售。
        </p>
        <h4>
          一、云智互联将本“软件”在中华人民共和国（“中国”）大陆地区（除香港特别行政区、澳门特别行政区、台湾地区外的中国境内）的非专有的使用权授予您。
          您可以：
        </h4>
        <p>
          1. 在一台计算机上安装、使用、显示、运行（“运行”）本“软件” 的一份副本。
        </p>
        <p>
          2.
          为了防止副本损坏而制作备份复制品。这些备份复制品不得通过任何方式提供给他人使用，并在您丧失该合法副本的所有权时，负责将备份复制品销毁。
        </p>
        <p>
          3.为了把本“软件”用于实际的计算机应用环境或者改进其功能、性能而进行必要的修改；但是，除本《协议》另有约定外，未经云智互联许可，不得向任何第三方提供修改后的软件。
        </p>
        <h4>二、您保证：</h4>
        <p>
          1.
          不在本《协议》之外，使用、复制、修改或转让本“软件”或其中的任一部分。
        </p>
        <p>
          2.
          只在一台计算机上使用本“软件”；一份软件许可不得在不同的计算机上共同或同时使用。
        </p>
        <p>
          3.
          只在以下前提完全满足的情况下，将本“软件”用于多用户环境或网络系统上：
        </p>
        <p>3.1.本“软件”明文许可用于多用户环境或网络系统上；</p>
        <p>3.2.使用本“软件”的每一节点及终端都已购买使用许可。</p>
        <p>
          4.
          不得对本“软件”进行反向工程、反向编译或反汇编；不得试图进行任何获得本“软件”原代码的访问或行为；不得对本“软件”或者本“软件”运行过程中释放到任何计算机终端内存中的数据、信息及该软件运行过程中客户端与服务器端的交互数据进行复制、更改、修改、挂接运行或创作任何衍生作品（包括但不限于以使用插件、外挂或非经授权的第三方工具/服务的形式接入本“软件”或与本“软件”相关的系统。”）。
        </p>
        <p>5. 不得发行、出租、信息网络传播、翻译本“软件”。</p>
        <p>6. 在本“软件”的所有副本上包含所有的版权标识。</p>
        <h4>三、权利转让</h4>
        <p>
          1. 您可将您在本《协议》项下的所有权利作永久性一次转让，转让的条件是：
        </p>
        <p>
          1.1.转让本“软件”（包括计算机软件，及可能附随的相关文档印刷材料）的所有部分；
        </p>
        <p>
          1.2.如果本“软件”为升级版本，任何转让必须包括本“软件”的所有前版本；
        </p>
        <p>1.3.您不得保留任何副本；</p>
        <p>1.4.转让后您的许可权即自行终止；</p>
        <p>1.5.受让人接受本《协议》的各项条款。</p>
        <h4>四、支持服务</h4>
        <p>
          1.
          如在本“软件”附随用户手册或其它材料中，云智互联明示将为您提供支持服务，则云智互联将依照该用户手册或其它材料中所述的各项政策和计划为您提供与本“软件”有关的支持服务（“支持服务”）。
        </p>
        <p>
          2.
          提供给您作为支持服务的一部分的任何附加软件代码（如有）应被视为本“软件”的一部分，并须遵照本《协议》中的各项条款。
        </p>
        <p>
          3.
          您明示同意，云智互联可将您提供给云智互联作为支持服务的一部分的技术信息（如有）用于商业用途，包括产品支持和开发。除了在为您提供支持服务时必须的情况外，云智互联在使用这些技术信息时不会以个人形式提及您。
        </p>
        <h4>五、软件的使用及软件的替换、修改和升级</h4>
        <p>
          1.
          使用本“软件”功能及其对应服务前，您需要根据云智互联规定的注册程序注册账号并同意其相应的服务协议；本“软件”依赖于互联网络方可实现其功能，在未链接到互联网络情况下，不能实现本“软件”的功能。同时，为了向您提供更好的服务，云智互联将不断完善本“软件”的功能，在您链接到互联网的前提下，本“软件”默认自动进行更新以完善其功能。
        </p>
        <p>
          2.
          云智互联保留在任何时候通过提前向您公告（包括但不限于客户端弹出页面、本“软件”官方网站、您提供的邮件地址）的方式为您提供本“软件”的替换版本或修改版本或升级版本以替换、修改或使本“软件”升级的权利和为这类替换、修改或升级收取费用的权利。该公告于发送或公布之日视为已送达收件人。因特殊原因（特殊原因包括但不限于：您提供的电子邮箱失效、您的邮箱设有邮件过滤、邮件拦截功能；等）导致您的电子邮件地址无法成功收到云智互联向您所提供的电子邮箱发送的公告，云智互联对此不承担任何责任。该公告所述内容将于公告载明的该内容的生效日期生效，如若公告未载明公告所述内容的生效日期，公告中所述内容将于公告发送或公布之日生效。
        </p>
        <p>
          3.
          如您不接受本“软件”的替换版本或修改版本或升级版本，请您主动自行卸载本“软件”；
          本“软件”新版本（指本“软件”的替换版本或修改版本或升级版本，视情况而定）发布后，您使用本“软件”新版本，则视为您完全接受本“软件”新版本；并且，本“软件”新版本发布后，云智互联不保证旧版本（指新版本发布之前的版本）的继续可用。云智互联保留因业务发展需要，单方面对本“软件”的部分功能效果进行改变或进行限制，您应承担此与此相关的风险。
        </p>
        <p>
          4.
          云智互联提供给您的本“软件”的任何替换版本或修改软件代码或升级版本，将被视为本“软件”的一部分并且要受到本《协议》条款的制约（除非本《协议》被随附本“软件”的替换或修改版本或升级版本的另外一份《协议》取代）。
        </p>
        <p>
          5.
          如果云智互联提供本“软件”的一个替换或修改版本或任何升级版本，则（a）您对本“软件”替换或修改版本或任何升级版本的使用条件是您接受本“软件”的这类替换或修改版本或升级版本以及任何随附的取代《协议》（如有），并且（b）您对本“软件”的所有先前版本的使用将被终止。
        </p>
        <h4>六、权利的保留：</h4>
        <p>
          1.
          为维持软件替换、修改和升级费用，云智互联保留在提供给您的软件中添加任意形式的广告，或以其他方式从您使用软件中获得利益的权利。
        </p>
        <p>2. 未明示授予的一切权利均为云智互联所有。</p>
        <h4>七、本“软件”的著作权</h4>
        <p>
          1.
          您不得去掉本“软件”上的任何版权标识，并应在其所有复制品上依照其现有表述方式标注其版权属于云智互联。
        </p>
        <p>
          2.
          本“软件”（包括但不限于本“软件”中所含的任何图像、照片、动画、录像、录音、音乐、文字和附加程序）、随附的印刷材料及本“软件”任何副本的著作权，均由云智互联拥有。
        </p>
        <p>3. 本“软件”及文档享有版权，并受国家版权法及国际协约条款的保护。</p>
        <p>
          4.
          您不可以从本“软件”中去掉其版权声明；并保证为本“软件”的复制品（全部或部分）复制版权声明。
        </p>
        <p>
          5.
          您同意不以任何形式复制本“软件”及程序、文档，并同意制止以任何形式非法复制本“软件”及文档。
        </p>
        <p>6. 您不可复制本“软件”随附的任何印刷材料。</p>
        <h4>八、出口限制</h4>
        <p>
          1.
          您同意不将本“软件”、其任何部分或任何属本“软件”的直接成果的任何程序或服务出口或转口给任何中国大陆外的任何国家或者地区。
        </p>
        <h4>九、不允诺</h4>
        <p>
          1.
          本《协议》所述明示担保，为担保的全部内容。在适用法律所允许的最大范围内，云智互联及其供应商提供的本“软件”和支持服务（如有）均为按现状及包含所有瑕疵状况下提供，不允诺其它不论是明示的、暗示的还是法定的任何保证和担保：包括但不限于本“软件”对特殊应用目的适销性或适应性，反应的精确性，结果的完整性，不含病毒及疏忽，针对本“软件”提供或不提供支持服务。
        </p>
        <h4>十、责任有限：</h4>
        <p>
          1.
          在适用法律所允许的最大范围内，云智互联或其供应商绝不就因使用或不能使用本“软件”所引起的或有关的无论是您或者任何第三方的任何间接的、意外的、直接的、特殊的、惩罚性的或其它任何损害（包括但不限于因人身伤害或财产损坏而造成的损害，因利润损失、数据损失、营业中断、计算机瘫痪或故障、商业信息的遗失而造成的损害，因未能履行包括诚信或相当注意在内的任何责任致使隐私泄露而造成的损害，因疏忽而造成的损害，或因任何金钱上的损失或任何其它损失而造成的损害）承担赔偿责任，即使云智互联或其任何供应商事先被告知该损害发生的可能性。即使补救措施未能达到预定目的，本损害赔偿排除条款将仍然有效。不论何种情况，云智互联及其供应商在本《协议》任何条款下所承担的全部责任，以及您可获得的赔偿（若由于违反售后担保，云智互联可按照本《协议》约定给您更换产品），以您购买本“软件”支付的款项为限。同时，云智互联对您或第三方提供的应用于或操作于本“软件”的内容或与该内容相关的其他内容而引起的任何索赔或损害不承担任何责任。
        </p>
        <h4>十一、许可终止：</h4>
        <p>
          1.
          如您未遵守本《协议》的各项条款和条件，云智互联可终止本《协议》。终止本《协议》时，您必须立即销毁本“软件”的所有复制品，或者将其归还给云智互联。
        </p>
        <p>
          2.
          通过向您提供本“软件”的任何替换或修改版本或升级版本的一份取代《协议》，并规定您使用这类替换、修改或升级版本的条件是您接受这类取代《协议》，云智互联可以终止本《协议》。
        </p>
        <h4>十二、适用、管辖法律：</h4>
        <p>
          1. 本《协议》的订立、执行和解释及争议的解决均应适用中国大陆地区法律。
        </p>
        <p>
          2.
          如您与云智互联就本《协议》内容或其执行发生任何争议，双方应进行友好协商；协商不成时，任何一方均可向云智互联所在地有管辖权的人民法院提起诉讼。
        </p>
        <h4>十三、特别提示：</h4>
        <p>
          1.
          为了不断提高本“软件”和服务的质量，我们将有可能搜集您对本“软件”进行使用的信息，并不定期地予以反馈。
        </p>
        <p>
          2.
          我们不会搜集您的姓名、地址、联系方式等个人信息以及文件内容等涉及信息安全的信息。
        </p>
        <p>
          3.
          以上搜集的信息仅仅为了市场分析需要，以便我们今后能够为您提供更好的功能和服务，云智互联对此数据严格保密。
        </p>
        <p>
          4.
          本条所指搜集信息的范围以云智互联适时的技术水平为判断标准。云智互联将尽最大努力力求判断的准确性，但因受到现实技术水平等的限制，云智互联仅依照自有的判断能力进行甄别收集。您已明确知悉上述内容，且认可云智互联的操作，愿意承担因此而可能造成的损失。
        </p>
        <h4>十四、其他条款</h4>
        <p>
          1. 本《协议》所定的任何条款的部分或全部无效者，不影响其它条款的效力。
        </p>
        <p>
          2.
          本《协议》的解释、效力及纠纷的解决，适用于中华人民共和国法律。若用户和云智互联之间发生任何纠纷或争议，首先应友好协商解决，协商不成的，用户在此完全同意将纠纷或争议提交云智互联所在地法院管辖。
        </p>
        <p>3. 本《协议》的一切解释权与修改权归云智互联。</p>
        <p>
          4.
          至此，您肯定已经详细阅读并已理解本《协议》，并同意严格遵守各条款和条件。
        </p> -->
      <div class="agreementCon">
        <infoCom v-if="type ==1"/>
        <infoCom2 v-else-if="type ==2"></infoCom2>
        <infoCom3 v-else-if="type ==3"></infoCom3>
      </div>
    </div>
    <div class="btnCon tac" v-if="type">
      <Button type="primary" @click="suerAgree">我已阅读并同意该协议</Button>
    </div>
  </div>
</template>
<script>
import infoCom from './info.vue'
import infoCom2 from './info2.vue'
import infoCom3 from './info3.vue'
export default {
  props: ['type'],
  components: {
    infoCom,
    infoCom2,
    infoCom3
  },
  data () {
    return {
      isShowTxt: false,
      isType: 1
    }
  },
  watch:{
    isType(){
      this.type =this.isType
    }
  },
  methods: {
    suerAgree () {
      
      this.$emit('suerAgree')
    }
  },
}
</script>
<style lang="scss" scoped>
.txtCon {
  width: 800px;
  height: 508px;

  .inCon {
    overflow: hidden;
    height: 410px;
    overflow-y: auto;
    text-align: left;
  }

}

.downloadMask2 {
  background-color: #f3f3f3;
  background: -webkit-linear-gradient(top, #f8f8f8 0, #eeeeee 20%);
  background: -moz-linear-gradient(top, #f8f8f8 0, #eeeeee 20%);
  background: -o-linear-gradient(top, #f8f8f8 0, #eeeeee 20%);
  background: linear-gradient(to bottom, #f8f8f8 0, #eeeeee 20%);
  background-repeat: repeat-x;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=#F8F8F8, endColorstr=#eeeeee, GradientType=0);
  border-radius: 4px;
  box-shadow: 0 0 10px rgba($color: #000000, $alpha: 0.6);
  width: 350px;
  height: 238px;
  padding: 0 10px;
  box-sizing: border-box;
  border: 1px solid rgb(2, 83, 158);
  overflow: hidden;

  h4 {
    font-size: 14px;
    text-align: left;
    text-indent: 10px;
    line-height: 36px;
    background: rgb(2, 83, 158);
    color: #fff;
    width: 358px;
    margin-left: -10px;

    img {
      margin: 10px 0 0 10px;
    }
  }

  &.txtCon {
    h4 {
      width: 670px;
    }
  }

  .closeBtn {
    font-size: 30px;
    right: 10px;
    top: -4px;
    color: #fff;
  }

  .inCon {
    width: 100%;
    background: #fff;
    border: 1px solid rgb(2, 83, 158);
    margin-top: 10px;
    padding: 10px 20px;

    h4,
    h3 {
      background: #fff;
      color: #000000;
      text-align: center;
      font-size: 18px !important;
      font-weight: bold;
    }

    h3 {
      margin: 10px 0;
    }

    h4 {
      font-size: 14px !important;
      text-align: left;
      line-height: 24px !important;
      margin: 10px 0;
    }

    p {
      line-height: 24px;
    }
  }

  a.contentCon {
    line-height: 90px;
    text-decoration: underline;
  }

  .contentCon {
    height: 90px;
    text-indent: 0px;

    img {
      width: 40px;
    }
  }
}

.btnCon {
  margin-top: 10px;
}
</style>
<style lang="scss" >
.MsoNormal {
  font-size: 14px;

}

.agreementCon {

  b {
    font-weight: bolder !important;
  }

  p {
    line-height: 30px;
  }
}
</style>